import { DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutCallinScriptDetailTable extends Layout {
    labelPrompts: Label;
    labelPromptsTotal: Label;
    sourceCallinScriptTemplateDetail: DataSource;
    tableAddedPrompts: Table;
}
